<ion-content class="container">
    <app-header class="hide-on-print" [title]="'Custom Cancel Report'"></app-header>
    <ng-container>

        <ion-row class="filter-row hide-on-print">
            <ion-grid>
                <ion-row>
                    <ion-col>
                        <ion-input type="text" [(ngModel)]="customerCode" placeholder="Enter customer code" class="ion-text-left color-light"  (keydown.enter)="onEnterKey($event)"></ion-input>
                    </ion-col>
                    <ion-col class="width-80px">
                        <ion-button (click)="searchCustomerCode()" color="gallaghergreen" class="btn-box-shadow btn-margin"><span>Show</span></ion-button>
                    </ion-col>
                    <ion-col>
                        <ion-input [disabled]="!submittedCustomerCode" type="text" [(ngModel)]="lastNameSearch" placeholder="Search last name" class="ion-text-left color-light"></ion-input>
                    </ion-col>
                </ion-row>
            </ion-grid>
        </ion-row>

        <div class="spinner-container" *ngIf="!loaded">
            <ion-spinner></ion-spinner>
        </div>
        
        <div class="content-container" *ngIf="loaded">
            <div *ngIf="submittedCustomerCode" class="top-header">
                <ion-row>
                    <ion-col>
                        <span><span class="bold-text">Cust:</span> {{currentCustomerCode}}&nbsp;&nbsp;&nbsp;{{customer?.name ?? ''}}</span>
                    </ion-col>
    
                    <ion-col class="align-right">
                        <span><span class="bold-text">Report Date:</span> {{today | date:'shortDate' }}</span>
                    </ion-col>
                </ion-row>
                <ion-row class="hide-on-print">
                    <ion-col>
                       
                    </ion-col>
    
                    <ion-col class="align-right">
                        <button class="printer-button hidden-for-print" (click)="changePrinterView()">Print</button>
                    </ion-col>
                </ion-row>
            </div>

            <div class="item-scroll-container" *ngIf="isShowData">
                <ng-container *ngFor="let wo of cancelOrders">
                    <ng-container *ngIf="isValid(wo[0])">
                        <div class="item-header">
                            <ion-row>
                            <ion-col class="bold">
                                {{wo[0].lastName}}, {{wo[0].firstName}}  {{wo[0].departmentCode}}-{{wo[0].employeeCode}}
                            </ion-col>
                        
                            <ion-col>
                                <strong>Start Date:</strong> {{wo[0].orderDate | date: 'MM/dd/yyyy'}}
                            </ion-col>
                        </ion-row>
                             <ion-row class="ion-justify-content-end ion-align-items-center">
                    <ion-col class="ion-justify-content-end ion-align-items-center">
                        <strong>Stop:</strong> {{wo[0].stopName}}
                    </ion-col>
                        <ion-col class="ion-justify-content-end ion-align-items-center">
                            <strong>Gar. ID Label:</strong> {{wo[0].stopCode}} {{wo[0].lockerNum}}
                        </ion-col>
                        <ion-col>
                            <strong>Cancel Order:</strong> {{wo[0].woCode}}
                        </ion-col>
                    </ion-row>
                            <ion-row class="label-header">
                                <ion-col size="2.1">
                                    <span>Description</span>
                                </ion-col>
                                <ion-col size="4.2">
                                    <span>Product</span>
                                </ion-col>
                                <ion-col size="2.1">
                                    <span>Barcode #</span>
                                </ion-col>
                                <ion-col size="2.1">
                                    <span>Date Collected</span>
                                </ion-col>
                                <ion-col size="1.5" class="align-right">
                                    <span>Loss Charge</span>
                                </ion-col>
                            </ion-row>
                        </div>
                        
                        <div class="data-item" *ngFor="let item of wo">
                             <ion-row >
                      <ion-col size="2.1">
                        {{item.description}}
                      </ion-col>
                      <ion-col size="4.2">
                        {{item.product}}
                      </ion-col>
                      <ion-col size="2.1">
                        {{item.barcode}}
                      </ion-col>
                      <ion-col size="2.1">
                        {{item.dateCollected === null ? 'Not Collected' : item.dateCollected | date: 'MM/dd/yyyy'}}
                      </ion-col>
                      <ion-col size="1.5" style="text-align: right;">
                        {{item.dateCollected === null ? (item.lossCharge | currency: 'USD') : '$0.00'}}
                      </ion-col>
                    </ion-row>
                        </div>
    
                          <ion-row class="data-footer">
                       <ion-col size="10">
                               <strong>Final Pickup Date and Potential Charges: {{wo[0].pickUpDate | date: 'shortDate'}}</strong> 
                        </ion-col>
                        
                        <ion-col size="2" style="text-align: right;">
                            <strong>{{wo.lossCharge | currency:'USD':'symbol':'1.2-2'}}</strong>
                        </ion-col>
                    </ion-row>
                    </ng-container>
                </ng-container>

                <ion-row *ngIf="submittedCustomerCode && cancelOrders.length>0" class="final-grand-total-row">
                    <ion-col size="10">
                        <strong>Grand Total Potential Loss Charge</strong>
                    </ion-col>
                    <ion-col size="2" style="text-align: right;">
                        <strong>{{totalLossCharge | currency:'USD':'symbol':'1.2-2'}}</strong>
                    </ion-col>
                </ion-row>
             <ion-row *ngIf="submittedCustomerCode && cancelOrders.length == 0" class="ion-justify-content-center ion-text-center">
                <ion-col size="12">
                    <ion-text color="danger">
                    There are no records for the query.
                    </ion-text>
                </ion-col>
                </ion-row>
            </div>
        </div>
    </ng-container>
</ion-content>